// src/__internal__/utils/useMemoDeep.ts
import { useEffect, useRef } from "react";
import compare from "react-fast-compare";
function useMemoDeep(next) {
  const previousRef = useRef(next);
  const previous = previousRef.current;
  const isEqual = compare(previous, next);
  useEffect(() => {
    if (!isEqual) {
      previousRef.current = next;
    }
  }, [next]);
  return isEqual ? previous : next;
}
export {
  useMemoDeep
};
